export default "__VITE_ASSET__2D8T8ayY__"